export default __webpack_public_path__ + "static/media/tracking-in-use.aa6ff443.png";